function pad0(t: number) {
  return t < 10 ? "0" + t.toString() : t.toString()
}

function formatShortDateDdMmYy(d: Date): string {
  const y = d.getFullYear()
  const yy = y % 100
  return pad0(d.getDate()) + "." + pad0(d.getMonth() + 1) + "." + pad0(yy)
}

/** 日历月差：`date` 比 `later` 早整 K 个月时返回 K（同一天或更早日视为满一个月） */
function wholeCalendarMonthsBefore(date: Date, later: Date): number {
  let months =
    (later.getFullYear() - date.getFullYear()) * 12 + (later.getMonth() - date.getMonth())
  if (later.getDate() < date.getDate()) months -= 1
  return months
}

function timeHm(d: Date): string {
  return pad0(d.getHours()) + ":" + pad0(d.getMinutes())
}

export function formatOnlineDate(date: Date | string | number) {
  if (!date) return ""
  const d = new Date(date)
  if (Number.isNaN(d.getTime())) return ""

  const now = new Date()
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  const dayStart = new Date(d.getFullYear(), d.getMonth(), d.getDate())

  const diffDays = Math.round((todayStart.getTime() - dayStart.getTime()) / (1000 * 60 * 60 * 24))
  const diffTime = now.getTime() - d.getTime()

  if (diffDays < 0) {
    /** 服务端时间早于本地「今天」时仍显示合法绝对时间 */
    return formatShortDateDdMmYy(d)
  }

  if (diffDays === 0) {
    if (diffTime <= 1000 * 60 * 15) {
      return "刚刚在线"
    }
    return "今天 " + timeHm(d)
  }
  if (diffDays === 1) return "昨天 " + timeHm(d)
  if (diffDays === 2) return "前天 " + timeHm(d)
  if (diffDays === 3) return "3天前"
  if (diffDays <= 6) {
    const cn: Record<number, string> = { 4: "4", 5: "5", 6: "6" }
    return `${cn[diffDays]}天前`
  }
  /** 已满 7 日未满 14 日 */
  if (diffDays < 14) return "1周前"
  /** 已满 14 日但未满一个完整自然月：按自然日数 */
  const monthsBehind = wholeCalendarMonthsBefore(dayStart, todayStart)
  if (monthsBehind < 1) return `${diffDays}天前`

  if (monthsBehind === 1) return "1个月前"

  /** 超过一个完整自然月：DD.MM.YY */
  return formatShortDateDdMmYy(d)
}

/**
 * 用于在线/最近活跃列表展示：对已含「在线」或仅用相对短语/短日期描述的不再追加后缀，避免出现「刚刚在线在线」。
 */
export function decorateOnlinePresenceLine(formatted: string): string {
  if (!formatted) return formatted
  if (formatted.includes("在线")) return formatted
  const t = formatted.trim()
  if (/(?:天前|周前|个月前)$/.test(t) || /^\d{2}\.\d{2}\.\d{2}$/.test(t)) return formatted
  return `${formatted}在线`
}
